import { useEffect, useState } from "react"

import { ContentBox, FieldListItem, Reorderable } from "web/components"
import { Select } from "web/components/Form/Controls"

import { sortByKey } from "web/services/helpers"

export default function EditFieldList({
  fields: fieldListItems,
  allFields,
  title = "",
}) {
  // local state used to achieve immediate feedback in UI after drag/drop
  // TODO: use swr local update instead
  const [_fields, setLayoutFields] = useState(
    sortByKey(fieldListItems, "ordinal")
  )

  useEffect(() => {
    setLayoutFields(sortByKey(fieldListItems, "ordinal"))
  }, [fieldListItems])

  function handleMoveField(fromIndex, toIndex) {
    const fieldsReordered = [..._fields]
    const [fieldToMove] = fieldsReordered.splice(fromIndex, 1)
    fieldsReordered.splice(toIndex, 0, fieldToMove)

    setLayoutFields(fieldsReordered)
    fieldListItems.reorder(fromIndex + 1, toIndex + 1)
  }

  function handleDeleteField(field) {
    return field.destroy()
  }

  function handleNewFieldSelected(value) {
    if (value === null) return
    return fieldListItems.add({ field_id: value.value })
  }

  const hasFields = fieldListItems.length !== 0
  const currentlySelectedFieldIds = fieldListItems.map((f) => f.field.id)
  const potentialNewFields = allFields.filter(
    (field) => !currentlySelectedFieldIds.includes(field.id)
  )

  function getFieldLabel(targetField) {
    const otherFieldsWithSameName = !!allFields.find(
      (field) =>
        field.label === targetField.label && field.id !== targetField.id
    )

    return otherFieldsWithSameName
      ? targetField.subject_type_label + " " + targetField.label
      : targetField.label
  }

  const options = sortByKey(
    potentialNewFields.map((field) => ({
      value: field.id,
      label: getFieldLabel(field),
    })),
    "label"
  )

  return (
    <ContentBox>
      {title && <div className="mb-1 text-lg font-bold">{title}</div>}
      {hasFields && (
        <Reorderable
          id="edit-field-list"
          itemListClass="flex flex-wrap"
          itemContainerClass="mt-2 mr-2"
          onMoveItem={handleMoveField}
        >
          {_fields.map((field) => (
            <FieldListItem
              key={field.id}
              label={getFieldLabel(field.field)}
              fieldId={field.id}
              presentation={field.presentation}
              presentations={field.field.presentations}
              changeFieldPresentation={fieldListItems.changeFieldPresentation}
              handleDeleteField={() => handleDeleteField(field)}
            />
          ))}
        </Reorderable>
      )}
      <div className="mt-5">
        <label className="relative mb-0.5 block text-sm text-neutral-5">
          Select Field to Add
        </label>
        <Select
          id="field-to-add"
          testId="select-field-to-add"
          value={null}
          onChange={handleNewFieldSelected}
          options={options}
        />
      </div>
    </ContentBox>
  )
}
